import Cookie from 'js-cookie'

Date.prototype.Format = function(fmt) {
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}

// flex最后一行补充dom个数计算 总数，单行数量
export function replenish_dom(arr, len) {
  let remainder = arr % len;
  return remainder ? (len - arr % len) : 0;
}

// 大数简化
export function numFormat(num) {
  if(num >= 10000) {
    num = Math.round(num/1000)/10 + 'w';
  } else if (num >= 1000) {
    num = Math.round(num/100)/10 + 'k';
  }
  return num;
}

// 根据 秒 转成 分钟：秒
export function videoDuration(second){
  let min = Math.floor(second / 60) + "";
  second = (second % 60) + "";
  let time =
    (min.length > 1 ? min : "0" + min) +
    ":" +
    (second.length > 1 ? second : "0" + second);
  return time;
}

// 中英文首字母排序
export function data_letter_sort (data, field) {
  var letter_reg = /^[A-Z]$/;
  var list = new Array();
  for (var i = 0; i < data.length; i++) {
    // 添加 # 分组，用来 存放 首字母不能 转为 大写英文的 数据
    list['#'] = new Array();
    // 首字母 转 大写英文
    let letter = (data[i][field]).substr(0, 1).toUpperCase();
    // 是否 大写 英文 字母
    if (!letter_reg.test(letter)) {
      letter = '#';
    }
    // 创建 字母 分组
    if (!(letter in list)) {
      list[letter] = new Array();
    }
    // 字母 分组 添加 数据
    list[letter].push(data[i]);
  }
  // 转换 格式 进行 排序；
  var resault = new Array();
  for (var key in list) {
    resault.push({
      letter: key,
      list: list[key]
    });
  }
  resault.sort(function (x, y) {
    return x.letter.charCodeAt(0) - y.letter.charCodeAt(0);
  });
  // # 号分组 放最后
  var last_arr = resault[0];
  resault.splice(0, 1);
  resault.push(last_arr);

  // 转换 数据 格式
  var json_sort = {}
  for (var i = 0; i < resault.length; i++) {
    json_sort[resault[i].letter] = resault[i].list;
  }

  return json_sort;
}

// 获取cookie中的userId
export function getUserId(type){
  if(Cookie.get('medtion_member_id')){
    return Cookie.get('medtion_member_id');
  }else{
    if(type){
      syslogin();
    }
    return '';
  }
}

// 登录
export function syslogin(){
  window.location.href='/login.jspx?fallbackUrl=' + encodeURIComponent(window.location.href);
}
// 注册
export function sysregister(){
  window.location.href='/register';
}

//这个是下载图片
//  解决跨域  imgsrc 文件全路径
// name 文件名
export function downloadIamge(imgsrc, name) {//下载图片地址和图片名
  var image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

    var a = document.createElement("a"); // 生成一个a元素
    var event = new MouseEvent("click"); // 创建一个单击事件
    a.download = name || "photo"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = imgsrc;
}

// 是否在桌面端显示
export function isBrainMedPC(){
  if(Cookie.get('platform') === 'BrainMedPC_Win' || Cookie.get('platform') === 'BrainMedPC_Mac'){
    return true;
  }else{
    return false;
  }
}

/*
* 为了解决精读问题
* */
// 加法运算
export function add(a, b) {
  const precision = Math.max(getPrecision(a), getPrecision(b));
  const multiplier = Math.pow(10, precision);
  return (Math.round(a * multiplier) + Math.round(b * multiplier)) / multiplier;
}

// 减法运算
export function subtract(a, b) {
  return add(a, -b);
}

// 乘法运算
export function multiply(a, b) {
  const precision = getPrecision(a) + getPrecision(b);
  const multiplier = Math.pow(10, precision);
  return (Math.round(a * multiplier) * Math.round(b * multiplier)) / (multiplier * multiplier);
}

// 除法运算
export function divide(a, b) {
  const precision = getPrecision(a) - getPrecision(b);
  const divisor = Math.pow(10, precision);
  return (Math.round(a / b * divisor)) / divisor;
}

// 获取浮点数的小数位数
export function getPrecision(num) {
  const str = String(num);
  const decimalIndex = str.indexOf('.');
  return decimalIndex === -1 ? 0 : str.length - decimalIndex - 1;
}
